export default __webpack_public_path__ + "static/media/img-0626-moldova-full-face.b781bb3c.png";